import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import { getCartTotal } from "../../services";
import { cart_actions } from "../../redux-store";
import { gaRemoveFromCart } from "../Tracking/Tracking";
import { formatPrice } from "../../utils/formatPrice";
import AdjustQuantityModal from "./AdjustQuantityModal";

const CartComponent = ({
  user,
  cart,
  symbol,
  total,
  remove_from_cart,
  update_cart_item,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setOpenModal(true);
  };

  const handleUpdateQuantity = (quantity) => {
    if (selectedItem) {
      update_cart_item(selectedItem, { quantity });
    }
  };

  return (
    <div>
      <Helmet>
        <title>eksplode | Cart List Page</title>
      </Helmet>
      <Breadcrumb title={"Cart Page"} />

      {cart.length > 0 ? (
        <section className="cart-section section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <table className="table cart-table table-responsive-xs">
                  <thead>
                    <tr className="table-head">
                      <th scope="col">Image</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Price</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Action</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>
                  {cart.map((item, index) => (
                    <tbody key={index}>
                      <tr>
                        <td>
                          <Link
                            to={`${process.env.PUBLIC_URL}/product/${item.product._id}`}
                          >
                            <img
                              src={item?.product?.product_images?.[0]?.image}
                              alt=""
                            />
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={`${process.env.PUBLIC_URL}/product/${item.product._id}`}
                          >
                            {item.product.product_name}
                          </Link>
                        </td>
                        <td>
                          <h2>
                            {formatPrice(item.product.product_price)}
                          </h2>
                        </td>
                        <td>
                          <button
                            className="btn btn-solid"
                            onClick={() => handleOpenModal(item)}
                          >
                            Adjust Quantity ({item.quantity})
                          </button>
                        </td>
                        <td>
                          <a
                            href="javascript:void(0)"
                            className="icon"
                            onClick={() => {
                              remove_from_cart({ unit: item });
                              gaRemoveFromCart(item.product, item.quantity);
                            }}
                          >
                            <i className="fa fa-times" />
                          </a>
                        </td>
                        <td>
                          <h2 className="td-color">
                            {formatPrice(
                              item.product.product_price * item.quantity
                            )}
                          </h2>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
                <table className="table cart-table table-responsive-md w-100 text-center">
                  <tfoot>
                    <tr>
                      <td className="text-right pr-3">Total Price :</td>
                      <td className="d-flex justify-content-center align-items-center">
                        <h2 className="ml-2 mb-0">{formatPrice(total)}</h2>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div className="row cart-buttons">
              <div className="col-6">
                <Link
                  to={`${process.env.PUBLIC_URL}/merchants`}
                  className="btn btn-solid"
                >
                  Continue Shopping
                </Link>
              </div>
              <div className="col-6">
                <Link
                  to={`${process.env.PUBLIC_URL}/${
                    user ? "checkout" : "login"
                  }`}
                  className="btn btn-solid"
                >
                  Check Out
                </Link>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="cart-section section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="col-sm-12 empty-cart-cls text-center">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/icon-empty-cart.png`}
                      className="img-fluid mb-4"
                      alt=""
                    />
                    <h3>
                      <strong>Your Cart is Empty</strong>
                    </h3>
                    <h4>Explore more shortlist some items.</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {selectedItem && (
        <AdjustQuantityModal
          open={openModal}
          setOpen={setOpenModal}
          item={selectedItem}
          updateQuantity={handleUpdateQuantity}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  symbol: state.data.symbol,
  total: getCartTotal(state.cart.items),
  cart: state.cart.items ? state.cart.items : [],
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  remove_from_cart: (unit) => dispatch(cart_actions.remove_from_cart(unit)),
  update_cart_item: (item, details) =>
    dispatch(cart_actions.update_cart_item(item, details)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartComponent);
